// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"636":"605c6c39","815":"605c6c39"}[chunkId] + ".chunk.css";
};